/**
 * Created by Allan on 2022/04/12.
 * Contact 84880528@qq.com.
 * 判断当前value是否添加上升或下降样式
 */
export default function(value){
    if(!value) return '';
    let $num=Number(value);
    return $num>1?'up':($num<1 && $num!==0?'down':'')
}



// WEBPACK FOOTER //
// ./src/filter/isDwonup.js